module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d859e71f6a54417d6f5d7ec226db6f43.png";